import React from 'react';
import Button from '../../Components/Button/Button';
import { useSession } from '../../Components/Session';

const RedesignPrompt = () => {
    const {setShowRedesign} = useSession();

    const showRedesign = () => {
        setShowRedesign(true);
    }

    return <div className="relative flex flex-col gap-4 rounded-lg shadow-md p-4 text-white bg-gradient-to-br from-brand to-brand-light text-center text-balance">
        <h1 className="text-xl font-bold">Ready for something new?</h1>
        <p>We've got a big update to the app, and you can try it now.</p>
        <p>It's easier to use, quicker to get around, and it's built to make your day-to-day work smoother.</p>
        <Button theme="light" className="text-brand" label="Try it out" onClick={showRedesign} />
    </div>
};

export default RedesignPrompt;
